import { render, staticRenderFns } from "./SchoolMaterialsPage.vue?vue&type=template&id=5a7670a8&scoped=true"
import script from "./SchoolMaterialsPage.vue?vue&type=script&lang=js"
export * from "./SchoolMaterialsPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolMaterialsPage.vue?vue&type=style&index=0&id=5a7670a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7670a8",
  null
  
)

export default component.exports